// 6-8 Educators PD Conference data — same structure, colors, links, sponsors as the source app
// audience changed to 6-8 educators

export const CONFERENCE = {
  title: "BCS District PD Conference",
  tagline: "Nurture. Guide. Empower.",
  subTagline: "AI in Teaching & Learning",
  audience: "6-8 educators",
  audienceSegment: "primary",
  date: "June 8, 2026",
  year: 2026,
  registrationNumber: "344915",
  registrationDeadline: "May 31, 2026",
  ceus: 12,
  schoologyAccessCode: "QM79-25D5-J63TQ",
  welcome:
    "Welcome, 6-8 educators! Today we explore how AI can support, inspire, and elevate middle school teaching.",
};

// Hero background image
export const HERO_BG_URL =
  "https://images.unsplash.com/photo-1755538497211-c4ebc7cc1a94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3klMjBlZHVjYXRpb24lMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NzIzNTU2MHww&ixlib=rb-4.1.0&q=85";

// Local logo paths
export const BCS_LOGO = "/bcs-logo.png";

// Lunch sponsor — ClearWinds Technologies
export const LUNCH_SPONSORS = [
  {
    name: "ClearWinds Technologies",
    logo: "/clearwinds-logo.png",
    url: "https://www.clearwinds.com/",
  },
];

// Announcements — shown on the Home page
export const ANNOUNCEMENTS = [
  {
    id: "check-in",
    title: "Check-in opens at 7:30 AM",
    body: "Come early to Huffman High School and enjoy a morning of line dancing, scrolling, and exercise. The first 100 to arrive between 7:30 am and 8:00 am will be entered into a drawing for a cash prize.",
  },
  {
    id: "device",
    title: "Bring your charged device",
    body: "All sessions are hands-on with AI tools — an iPad, tablet or laptop is needed if you have one.",
  },
  {
    id: "ceus",
    title: "Earn 12 CEUs for the Nurture. Guide. Empower. Conference",
    body: "To earn 12 CEUs, register via PowerSchool PD (344826) and complete all assignments (Pre Lessons, Sessions, Post Lessons) in Schoology. To enroll in the Schoology course, use the access code RM9Z-28QQ-J8GQ8 to enroll.",
  },
  {
    id: "book",
    title: "Do not forget to get your book signed",
    body: "Expand your learning by reading Act Now. You will need to read the book to complete your Post Lessons. Keynote Speaker, Dr. Adam Phyall, will be signing copies of the book during lunch.",
  },
  {
    id: "assistance",
    title: "Need assistance during the conference",
    body: "Find a person in an orange vest.",
  },
];

// Agenda items
export const AGENDA = [
  {
    id: "morning",
    time: "7:30 - 8:30 AM",
    title: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment",
    description: "All groups attend. Kick off the day, get moving, and find your group!<br/><br/>Click on My Group to determine your assigned group.",
    location: "Auditorium",
    type: "general",
  },
  {
    id: "keynote",
    time: "8:30 - 9:15 AM",
    title: "Keynote: Dr. Adam Phyall, Director of Professional Learning and Leadership, All4Ed, ISTE+ASCD Board Member",
    description: "Welcome and opening keynote address.",
    location: "Auditorium",
    type: "keynote",
  },
  {
    id: "s1",
    time: "9:30 - 10:30 AM",
    title: "Session 1",
    description: "First session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
  {
    id: "s2",
    time: "10:45 - 11:45 AM",
    title: "Session 2",
    description: "Second session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
  {
    id: "lunch",
    time: "11:45 AM - 1:00 PM",
    title: "Lunch",
    description: "All groups break for lunch together. <strong>Dr. Phyall will be autographing his book \"ACT Now\" for teachers during lunch.</strong>",
    location: "Cafeteria",
    type: "break",
  },
  {
    id: "s3",
    time: "1:15 - 2:15 PM",
    title: "Session 3",
    description: "Third session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
];

// 3 sessions
export const SESSIONS = [
  {
    id: "ai-early-elementary",
    title: "AI in Middle Schools",
    location: "Rooms C205, C206, C207, or C208",
    description: "AI in Middle Schools, led by EdFarm instructors, is a hands-on professional learning session designed specifically for grades 6–8 educators to explore how artificial intelligence can support teaching, learning, and student engagement in the middle school classroom. Participants will examine practical ways to use AI for lesson planning, student creativity, differentiation, critical thinking, and classroom workflow while maintaining responsible and ethical use. The session will also help educators understand how to guide students in using AI as a learning support rather than a replacement for original thinking. By the end of the session, middle school teachers will leave with practical strategies, resources, and confidence to integrate AI thoughtfully and effectively into instruction.",
    icon: "sparkles",
  },
  {
    id: "ai-prompting",
    title: "Content Specific Rotation",
    location: "English Language Arts Teachers - Newsela Computer Lab C212\nMath Teachers - Math Magma Computer Lab C214\nScience Teachers - Gizmos Computer Lab B117\nSocial Studies Teachers - Social Studies Curriculum Overview Computer Lab C148\nNon-Core Teachers - Schoology Computer Lab C211",
    description:
      "Gizmos\nParticipants will engage with Gizmos to support hands-on learning in science and mathematics through interactive simulations and inquiry-based activities. Teachers will explore strategies for increasing student engagement, reinforcing key concepts, and promoting critical thinking through virtual investigations.\n\nMagma Math\nParticipants will learn how to use Magma Math to strengthen mathematical reasoning, collaborative learning, and standards-based instruction in middle grades mathematics. The session will highlight real-time formative assessment tools, student discourse strategies, and data-informed instructional decisions.\n\nNewsela\nTeachers will explore how Newsela can support literacy and content-area instruction through engaging, differentiated informational texts. The session will focus on building reading comprehension, vocabulary development, and student discussion using standards-aligned resources across content areas.\n\nSchoology GEMS\nSchoology GEMS is a hands-on, interactive professional learning experience designed to help educators unlock the hidden power of Schoology and transform their digital classrooms one gem at a time. Whether you are a novice user just getting started or an advanced user looking to refine and elevate your course design, this session will provide practical strategies to personalize learning, streamline navigation, improve communication, and increase student engagement. Participants will discover simple yet powerful features that help students stay organized, connected, and successful while creating a more efficient and engaging learning environment for teachers. Each \"Gem\" is easy to implement, classroom-ready, and intentionally designed to make your Schoology course more polished, interactive, and impactful. Through guided exploration and hands-on practice, educators will leave with actionable ideas and tools they can immediately apply to their courses. By the end of the session, participants will feel more confident using Schoology to create organized, student-centered digital learning experiences that truly shine.\n\nSocial Studies Curriculum Overview\n6-8 Social Studies teachers will explore the Cengage social studies curriculum with a focus on standards alignment, lesson design, and instructional pacing. Participants will examine strategies that support literacy, inquiry, and student engagement in history, civics, geography, and economics.",
    icon: "wand",
  },
  {
    id: "schoology-gems",
    title: "Magic School AI & AI Prompting",
    location: "Computer Labs C229, C233, C240, or Science Lab",
    description:
      "A hands-on professional learning session designed to help educators discover practical strategies and hidden features within Schoology that enhance organization, communication, personalization, and student engagement. Participants will explore classroom-ready tools and techniques that support the creation of polished, student-centered digital learning experiences for learners at all levels.",
    icon: "shield",
  },
];

// 3 GROUPS — same colors and structure as source
export const GROUPS = [
  {
    id: "learning_architects",
    name: "Learning Architects",
    bandLabel: "Green Band",
    color: "#2F855A",
    accent: "#FFFFFF",
    icon: "construct",
  },
  {
    id: "digital_designers",
    name: "Digital Designers",
    bandLabel: "Red Band",
    color: "#C53030",
    accent: "#FFFFFF",
    icon: "palette",
  },
  {
    id: "integration_engineers",
    name: "Integration Engineers",
    bandLabel: "Yellow Band",
    color: "#F6B829",
    accent: "#FFFFFF",
    icon: "network",
  },
];

// Per-group rotation through ALL three sessions
export const ROTATIONS = {
  learning_architects: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Dr. Adam Phyall, Director of Professional Learning and Leadership, All4Ed, ISTE+ASCD Board Member", location: "Auditorium" },
    { time: "9:30 - 10:30 AM", session: "Magic School AI & AI Prompting", location: "Computer Labs C229, C233, C240, or Science Lab" },
    { time: "10:45 - 11:45 AM", session: "AI in Middle Schools", location: "Rooms C205, C206, C207, or C208" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Lunchroom" },
    { time: "1:15 - 2:15 PM", session: "Content Specific Rotation", location: "English Language Arts Teachers - Newsela Computer Lab C212\nMath Teachers - Math Magma Computer Lab C214\nScience Teachers - Gizmos Computer Lab B117\nSocial Studies Teachers - Social Studies Curriculum Overview Computer Lab C148\nNon-Core Teachers - Schoology Computer Lab C211" },
  ],
  digital_designers: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Dr. Adam Phyall, Director of Professional Learning and Leadership, All4Ed, ISTE+ASCD Board Member", location: "Auditorium" },
    { time: "9:30 - 10:30 AM", session: "AI in Middle Schools", location: "Rooms C205, C206, C207, or C208" },
    { time: "10:45 - 11:45 AM", session: "Content Specific Rotation", location: "English Language Arts Teachers - Newsela Computer Lab C212\nMath Teachers - Math Magma Computer Lab C214\nScience Teachers - Gizmos Computer Lab B117\nSocial Studies Teachers - Social Studies Curriculum Overview Computer Lab C148\nNon-Core Teachers - Schoology Computer Lab C211" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Lunchroom" },
    { time: "1:15 - 2:15 PM", session: "Magic School AI & AI Prompting", location: "Computer Labs C229, C233, C240, or Science Lab" },
  ],
  integration_engineers: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Dr. Adam Phyall, Director of Professional Learning and Leadership, All4Ed, ISTE+ASCD Board Member", location: "Auditorium" },
    { time: "9:30 - 10:30 AM", session: "Content Specific Rotation", location: "English Language Arts Teachers - Newsela Computer Lab C212\nMath Teachers - Math Magma Computer Lab C214\nScience Teachers - Gizmos Computer Lab B117\nSocial Studies Teachers - Social Studies Curriculum Overview Computer Lab C148\nNon-Core Teachers - Schoology Computer Lab C211" },
    { time: "10:45 - 11:45 AM", session: "Magic School AI & AI Prompting", location: "Computer Labs C229, C233, C240, or Science Lab" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Lunchroom" },
    { time: "1:15 - 2:15 PM", session: "AI in Middle Schools", location: "Rooms C205, C206, C207, or C208" },
  ],
};

export const KEYNOTE = {
  name: "Dr. Adam Phyall",
  title: "Director of Professional Learning and Leadership, All4Ed, ISTE+ASCD Board Member",
  image:
    "https://customer-assets.emergentagent.com/job_deploy-base44/artifacts/1iktafnc_image.png",
  bio: "Bio coming soon.",
};

export const RESOURCES = [
  { label: "Nurture.Guide.Empower. Conference Website", url: "https://bcsit.org/" },
  { label: "PowerSchool PD", url: "https://bhm.schoology.com/" },
  { label: "Schoology", url: "https://alsde.truenorthlogic.com/ia/empari/login/index" },
];

export const AI_GAMES = [
  {
    title: "AI or Human",
    description:
      "AI-generated media content has come to stay, looking more human than ever. Play the game and try to guess the difference between what is AI or Human.",
    url: "https://ai-or-human.github.io/",
  },
  {
    title: "Most Likely Machine",
    description:
      "Most Likely Machine is an interactive learning experience that helps students understand how algorithms work and how bias can influence automated decisions. Through a playful, school-themed activity, students build and test algorithms, then reflect on how personal assumptions, data choices, and weighting decisions can affect outcomes. This is a strong classroom resource for teaching AI literacy, digital citizenship, fairness, and responsible technology use in a way that is engaging and age-appropriate.",
    url: "https://mostlikelymachine.artefactgroup.com/",
  },
  {
    title: "Quick Draw",
    description:
      "Quick, Draw! is an interactive Google AI experiment where users quickly sketch objects while a neural network attempts to guess the drawings in real time, helping demonstrate how machine learning works through fun, hands-on gameplay.",
    url: "https://quickdraw.withgoogle.com/",
  },
  {
    title: "Say What You See",
    description:
      "Say What You See is an interactive Google Arts & Culture AI experiment that helps users strengthen image-reading and AI prompting skills by carefully describing AI-generated images to recreate them as accurately as possible. The activity encourages critical thinking, observation, descriptive writing, and the creation of strategic prompts while providing a fun and engaging way for students and educators to learn how AI interprets language and visuals.",
    url: "https://artsandculture.google.com/experiment/say-what-you-see/jwG3m7wQShZngw?hl=en",
  },
  {
    title: "Semantris",
    description:
      "Semantris is a Google AI word-association game that uses machine learning to understand the meaning behind words and phrases, helping students explore vocabulary, semantic relationships, critical thinking, and how AI interprets language in a fun, fast-paced way.",
    url: "https://research.google.com/semantris",
  },
  {
    title: "Test Yourself: Which image is made by AI?",
    description:
      "Test Yourself is an interactive image-recognition game where users test their ability to identify which image was generated by artificial intelligence across multiple rounds. This activity is a strong classroom tool for building AI literacy, visual analysis, critical thinking, and discussion about how realistic AI-generated content can appear.",
    url: "https://game.agcs.works/",
  },
  {
    title: "Twin Pics",
    description:
      "Twin Pics is a daily AI image challenge where players use prompts to recreate a mystery image as closely as possible, earning higher scores based on accuracy. Because a new challenge is released each day, participants are encouraged to return daily to strengthen their AI prompting skills while learning how concise writing, detailed descriptions, and strategic word choice impact AI-generated results. It also serves as a fun classroom icebreaker that encourages creativity, collaboration, critical thinking, and discussion around how AI interprets language and prompts.",
    url: "https://twinpics.ai/",
  },
  {
    title: "Two Truths & AI",
    description:
      "An interactive digital literacy activity from Common Sense Media that challenges students to identify AI-generated content while building critical thinking and media literacy skills.",
    url: "https://www.commonsense.org/two-truths-and-ai",
  },
];
